import httpBase from "../utils/http.utils";
import {
  GET_SOCIAIR_PROFILES,
  FETCH_SOCIAL_PAGES,
  LINK_SOCIAL_MEDIA_PROFILE,
  DELETE_SOCIAL_MEDIA_PROFILE
} from "../constants/url";

export const getSociairProfilesApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().get(GET_SOCIAIR_PROFILES, {
        params: params,
      });
      // Pass the entire response.data to handle both formats
      // New format: {is_connected: bool, profiles: [], error: null}
      // Old format: [profile1, profile2, ...]
      successCallback(response.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const createSociairTenantApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post(
        "/sociar_webhook/create-sociar-tenant",
        data
      );
      successCallback(response.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const fetchSocialPagesApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post(FETCH_SOCIAL_PAGES, data);
      successCallback(response.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const linkSocialMediaProfileApi = ({
  socialType,
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post(
        `${LINK_SOCIAL_MEDIA_PROFILE}/${socialType}`,
        data
      );
      successCallback(response.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const deleteSocialMediaProfileApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().delete(DELETE_SOCIAL_MEDIA_PROFILE, { data: data });
      successCallback(response.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};

export const updateProfileStatusApi = ({
  profileId,
  status,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post(
        `/sociar_webhook/update-profile-status/${profileId}?status=${status}`
      );
      successCallback(response.data);
    } catch (e) {
      failureCallback(e);
    } finally {
      finalCallback();
    }
  };
};
